import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { RegistrationForm } from './components/RegistrationForm';
import { WhatYouLearn } from './components/WhatYouLearn';
import { WhoItsFor } from './components/WhoItsFor';
import { Instructor } from './components/Instructor';
import { Urgency } from './components/Urgency';
import { Footer } from './components/Footer';
import { ThankYou } from './pages/ThankYou';
function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="w-full min-h-screen bg-navy font-inter" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <RegistrationForm data-id="element-3" />
      <WhatYouLearn data-id="element-4" />
      <WhoItsFor data-id="element-5" />
      <Instructor data-id="element-6" />
      <Urgency data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-9">
      <Routes data-id="element-10">
        <Route path="/" element={<LandingPage data-id="element-12" />} data-id="element-11" />
        <Route path="/gracias" element={<ThankYou data-id="element-14" />} data-id="element-13" />
      </Routes>
    </BrowserRouter>;
}